import { pm2DeployStart, pm2DeployBefore, pm2OnStop, pm2DeployAfter, pm2Revert } from '../deploy/pm2/pm2'
import { deployUpload } from '../deploy/upload'
import { healthCheck } from '../deploy/healthCheck'
import { PartialCiConfig, PartialDeployConfig } from './interface'
import { setupDynamicArgs } from '../deploy/environments/setupDynamicArgs'


export const ciConfigDefaults: PartialCiConfig = {
  build: {
    before: [],
    main: [
      'yarn build',
    ],
    after: []
  },
  deploy: {
    before: [],
    main: [
      'yarn ci:deploy',
    ],
    after: []
  },
  stop: {
    before: [],
    main: [
      'yarn ci:stop'
    ],
    after: []
  },
  revert: {
    before: [],
    main: [
      'yarn ci:revert'
    ],
    after: []
  }
}

export const deployConfigDefaults: PartialDeployConfig = {
  requiredEnvVars: ['CI_COMMIT_SHORT_SHA', 'CI_TOOLS_COMMIT_TIMESTAMP', 'CI_COMMIT_TAG'],
  setupDynamicArgs: setupDynamicArgs,
  deployBefore: pm2DeployBefore, // Using pm2 deploy before to setup vars for pm2 upload and deploy
  deployUpload: deployUpload, // Using tar archive ssh upload as default (deployUploadFiles is the per-file alternative)
  deployStart: pm2DeployStart, // Using pm2 deploy as default
  healthCheck: healthCheck, // Using default basic health check
  deployAfter: pm2DeployAfter, // Using pm2 cleanup as default
  onStop: pm2OnStop, // Using pm2 onStop as default
  onRevert: pm2Revert, // Using pm2 revert as default
  environments: [],

}